import { visit } from 'graphql';
import graphql from 'graphql-anywhere';
import { getDirectiveType, nodeHasComputedDirectives } from './directive-utils';
import { difference, isEqual } from './set-utils';
function _listDocumentComputedDirectives(doc) {
    if (doc == null) {
        return [];
    }
    const computedDirectives = new Set();
    visit(doc, {
        Field(node) {
            var _a;
            if (nodeHasComputedDirectives(node)) {
                const computedDirective = (_a = node.directives) === null || _a === void 0 ? void 0 : _a.find((d) => d.name.value === 'computed');
                const directiveType = getDirectiveType(computedDirective);
                computedDirectives.add(`${directiveType}:${node.name.value}`);
            }
        },
    });
    return [...computedDirectives];
}
function _documentHasComputedDirectives(doc) {
    return _listDocumentComputedDirectives(doc).length > 0;
}
export function resolveData(data, operation, entities) {
    const { mixedQuery, originalQuery } = operation;
    let pendingResolvers = new Set();
    let resolvedResolvers = new Set();
    const resolver = (fieldName, _root, _, __, info) => {
        var _a;
        const root = _root == null ? {} : _root;
        const { resultKey } = info;
        const { __typename: typeName } = root;
        const aliasValue = root[resultKey];
        const nonAliasValue = root[fieldName];
        const isAliasedField = aliasValue !== nonAliasValue;
        if (aliasValue !== undefined || nonAliasValue !== undefined) {
            return aliasValue || nonAliasValue;
        }
        const shouldUseEntity = ((_a = entities[typeName]) === null || _a === void 0 ? void 0 : _a.fields[fieldName]) != null;
        if (!shouldUseEntity) {
            return isAliasedField ? aliasValue : nonAliasValue;
        }
        const { resolver, dependencies } = entities[typeName].fields[fieldName];
        const resolverId = `${typeName}:${fieldName}`;
        if (!_documentHasComputedDirectives(dependencies)) {
            resolvedResolvers.add(resolverId);
            return resolver(root);
        }
        const dependentResolvers = _listDocumentComputedDirectives(dependencies);
        if (dependentResolvers.some((d) => !resolvedResolvers.has(d))) {
            pendingResolvers.add(resolverId);
            return undefined;
        }
        else {
            resolvedResolvers.add(resolverId);
            return resolver(root);
        }
    };
    let resolvedData = graphql(resolver, mixedQuery, data);
    let prevPendingResolvers = new Set();
    let prevResolvedResolvers = new Set();
    while (pendingResolvers.size > 0) {
        prevResolvedResolvers = resolvedResolvers;
        resolvedData = graphql(resolver, mixedQuery, resolvedData);
        prevPendingResolvers = pendingResolvers;
        pendingResolvers = difference(pendingResolvers, resolvedResolvers);
        if (isEqual(prevResolvedResolvers, resolvedResolvers) &&
            isEqual(prevPendingResolvers, pendingResolvers)) {
            throw new Error('Irresoluble dependency chain found.');
        }
    }
    return graphql(resolver, originalQuery, resolvedData);
}
//# sourceMappingURL=resolve-data.js.map